export default "__VITE_ASSET__BWyZxlbC__"